const apiUrl =
  import.meta.env.VITE_API_URL || 'http://localhost:3000';

const env = {
  name: import.meta.env.MODE,
  api: {
    url: apiUrl,
  },
} as const;

export default env;
